import React, { PureComponent } from "react";
import styled from "styled-components";
import _ from "lodash";
import PropTypes from "prop-types";
import Fuse from "fuse.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch as fasSearch } from "@fortawesome/free-solid-svg-icons";
import TextInput from "./TextInput";
import { getTimeWindow } from "../helpers/location";

library.add(fasSearch);

const SearchContainer = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: 9px;
    right: 10px;
    height: 12px;
    color: #b8c4c9;
  }
  input[type="text"] {
    font-size: 12px;
    background: #fefefe;
    color: #56666c;
    box-shadow: 0 1px 5px 0 rgba(86, 102, 108, 0.24);
    border-radius: 2px;
    border: none;
    line-height: 30px;
    height: 30px;
    padding: 0 10px;

    ::placeholder {
      color: #b8c4c9;
    }
  }
`;

const LocationsContainer = styled.div`
  margin-top: 10px;
  padding: 5px;
  background: #fefefe;
  box-shadow: 0 1px 5px 0 rgba(86, 102, 108, 0.24);
  border-radius: 2px;
`;

const LocationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  &:nth-child(odd) {
    background: rgba(89, 156, 245, 0.15);
    border-radius: 2px;
  }
  &:hover {
    background: rgba(89, 156, 245, 0.5);
  }
`;

const LocationIcon = styled.div`
  display: inline-block;
  text-align: center;
  margin: 10px 0 10px 10px;
`;

const LocationNumber = styled.span`
  display: block;
  width: 14px;
  height: 14px;
  text-align: center;
  font-family: Lato;
  font-size: 10px;
  line-height: 14px;
  color: ${({ color }) => color || "#C4C4C4"};
  background: #fff;
  border-radius: ${({ type }) => (type === "dropoff" ? 0 : "50%")};
  border: 2px solid ${({ color }) => color || "#C4C4C4"};
`;

const LocationInfo = styled.div`
  padding: 5px 10px;
  width: auto;
  font-size: 12px;
  color: #56666c;
  p {
    margin: 2px 0;
  }
`;

const LocationInfoTop = styled.div`
  display: flex;
  justify-content: space-between;
  b {
    display: block;
  }
  b.time-window {
    white-space: nowrap;
  }
  .vehicle-id {
    color: #599cf5;
  }
`;

class Search extends PureComponent {
  renderLocations = () => {
    const locationsHTML = [];
    const { keyword, locations } = this.props;
    const searchOptions = {
      keys: ["location_id", "location_name", "name", "address", "type"],
    };
    let locationsCount = 0;

    if (!!keyword) {
      const fuse = new Fuse(locations, searchOptions);
      const filteredLocations = fuse.search(keyword, { limit: 3 });

      _.forEach(filteredLocations, (location) => {
        if (location.location_id) {
          locationsHTML.push(
            <LocationContainer
              key={`${location.vehicleId}-${location.number}`}
              onClick={this.selectLocation(location)}
            >
              <LocationIcon color={`#${location.color}`} type={location.type}>
                <LocationNumber
                  className="number"
                  color={`#${location.color}`}
                  type={location.type}
                >
                  {location.number}
                </LocationNumber>
              </LocationIcon>
              <LocationInfo>
                <LocationInfoTop>
                  <b className="location-id">
                    ID: {location.location_id}{" "}
                    {location.type ? `(${location.type})` : ""}
                  </b>
                  <b className="time-window">{getTimeWindow(location)}</b>
                </LocationInfoTop>
                {location.location_name && <p>{location.location_name}</p>}
                {location.address && <p>{location.address}</p>}
                <p className="vehicle-id">Vehicle: {location.vehicleId}</p>
              </LocationInfo>
            </LocationContainer>
          );
        }

        locationsCount = locationsCount + 1;
        return true;
      });
    }

    return (
      locationsHTML.length > 0 && (
        <LocationsContainer>{locationsHTML}</LocationsContainer>
      )
    );
  };

  render() {
    const { keyword } = this.props;

    return (
      <SearchContainer>
        <form>
          <FontAwesomeIcon icon={"search"} />
          <TextInput
            type="text"
            name="keyword"
            value={keyword}
            onChange={this.handleChange}
            placeholder="Search for a stop"
          />
        </form>
        {this.renderLocations()}
      </SearchContainer>
    );
  }

  selectLocation = (location) => {
    return function open() {
      this.props.updateLocationState(location);
    }.bind(this);
  };

  handleChange = (e) => {
    this.props.updateKeyword(e.target.value);
  };
}

Search.propTypes = {
  keyword: PropTypes.string,
  values: PropTypes.object,
  locations: PropTypes.array.isRequired,
  updateLocationState: PropTypes.func.isRequired,
  updateKeyword: PropTypes.func.isRequired,
};

export default Search;
